var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M8.97 17.9l-4.42-4.74a.75.75 0 10-1.1 1.02l4.6 4.94c.47.5 1.26.53 1.77.06l.06-.06 12.67-13.6a.75.75 0 00-1.1-1.03L8.97 17.89z"}})}
var staticRenderFns = []

export { render, staticRenderFns }